import { HatchCoverMoveDto } from '@operations/app/api'
import { SelectOption } from '@operations/app/models'
import { FilterChip } from '@operations/components/filter/filter.model'
import { HatchCoverMoveStore } from '@operations/stores/HatchCoverMoveStore'
import { action, computed, makeObservable, observable } from 'mobx'
import { HatchcoverFilter } from '../models/hatchcover-filters.model'

export class HatchcoverFilterUIStore {
  isOpen = false
  filter?: HatchcoverFilter | null
  searchValue?: string
  constructor(private hatchcoverMoveStore: HatchCoverMoveStore) {
    makeObservable(this, {
      isOpen: observable,
      filter: observable,
      searchValue: observable,
      toggle: action,
      setFilter: action,
      removeFilter: action,
      filteredItems: computed,
      uniqueEquipments: computed,
      filterChips: computed,
    })
  }

  public setFilter(filter?: HatchcoverFilter | null) {
    this.filter = filter
  }

  public toggle(): void {
    this.isOpen = !this.isOpen
  }

  public removeFilter(filter: FilterChip): void {
    const key = filter.key as keyof HatchcoverFilter

    if (this.filter) {
      const filterValue = this.filter[key]

      if (Array.isArray(filterValue)) {
        this.filter[key] = (filterValue as any).filter((x: string) => x !== filter.value)
      } else {
        this.filter[key] = null
      }
    }
  }

  public get filterChips() {
    const filterChips: FilterChip[] = []

    if (this.filter) {
      for (const propName in this.filter) {
        const key = propName as keyof HatchcoverFilter
        const filterValue = this.filter[key]

        if (!filterValue) continue
        filterChips.push({
          key: propName,
          value: filterValue as string,
          label:
            key === 'equipmentName'
              ? this.uniqueEquipments.find(e => e.value === filterValue)?.label
              : (filterValue as string),
        })
      }
    }

    return filterChips
  }

  public get uniqueEquipments(): SelectOption[] {
    return this.hatchcoverMoveStore.cranes.map(crane => ({
      id: crane.id,
      value: crane.id,
      label: crane.name,
    }))
  }

  public get filteredItems(): HatchCoverMoveDto[] {
    const { filter, hatchcoverMoveStore } = this
    return hatchcoverMoveStore.items
      .filter(item => {
        if (filter) {
          return Object.entries(filter).every(([key, value]) => {
            if (!value) return true

            switch (key) {
              case 'equipmentName':
                return item.equipmentId === value
              case 'direction':
                return item.direction.toLowerCase() === value.toLowerCase()
              default:
                return true
            }
          })
        }
        return true
      })
      .sort((a, b) => new Date(b.at).getTime() - new Date(a.at).getTime())
  }
}
